import { INavigationConfig } from '~/src/dash/views/common';

export const getRuleNavigationConfig = (enableExceptions: boolean): INavigationConfig => {
  if (enableExceptions) {
    return {
      tabs: [
        { key: 'Rule', label: 'Rule', value: 0, tKey: 'Rule' },
        { key: 'Exceptions', label: 'Exceptions', value: 1, tKey: 'Exceptions' },
        {
          key: 'Allowed Creatives',
          label: 'Allowed Creatives',
          value: 2,
          tKey: 'AllowedCreatives',
        },
      ],
    };
  }

  return {
    tabs: [
      { key: 'Rule', label: 'Rule', value: 0, tKey: 'Rule' },
      {
        key: 'Allowed Creatives',
        label: 'Allowed Creatives',
        value: 1,
        tKey: 'AllowedCreatives',
      },
    ],
  };
};
